(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-cultivate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!reduce.matches) return;
    document.querySelectorAll('[data-reduced-motion-pause] video').forEach(function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
    });
  })();

  // Seamless loop for a cinemagraph that does not return to its first frame:
  // two copies of the clip; a moment before one ends the other starts from
  // zero and fades in over it. Playback rate is applied to both, so a clip
  // the model made too lively can run at half speed. Re-runnable, because
  // the theme editor and the dev server hot-swap section HTML.
  (function () {
    function bind(wrap) {
      if (wrap.dataset.crossfadeBound) return;
      var vids = wrap.querySelectorAll('video');
      if (vids.length < 2) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      if (phone && wrap.dataset.mobile !== 'true') return;
      // On a phone the clip plays only where it can stream: Safari and every
      // iPhone browser take the HLS playlist and pick a rendition for the
      // connection. A browser without HLS would fetch the full 1080p MP4
      // over mobile data, so it keeps the still instead.
      if (phone) {
        var hls = vids[0].querySelector('source[type="application/x-mpegURL"], source[type="application/vnd.apple.mpegurl"]');
        if (hls && !vids[0].canPlayType('application/vnd.apple.mpegurl')) return;
      }
      wrap.dataset.crossfadeBound = '1';

      var rate = parseFloat(wrap.dataset.rate) || 1;
      var fade = parseFloat(wrap.dataset.fade);
      if (isNaN(fade)) fade = 1.5;
      // Seconds of media cut from the end: generated clips often fade or
      // shift colour in their last moments, so the loop hands over early.
      var trim = parseFloat(wrap.dataset.trim) || 0;
      wrap.style.setProperty('--hero-video-fade', fade + 's');

      var a = vids[0], b = vids[1], active = a, idle = b, switching = false;
      [a, b].forEach(function (v) {
        v.loop = fade <= 0;
        v.muted = true;
        v.playsInline = true;
        v.playbackRate = rate;
      });
      // The markup preloads nothing; the first copy fetches now, the second
      // once the first is actually playing (from cache on a CDN).
      a.preload = 'auto';
      if (fade <= 0) {
        var solo = a.play();
        if (solo && solo.catch) solo.catch(function () {});
        return;
      }
      a.addEventListener('playing', function warm() {
        a.removeEventListener('playing', warm);
        b.preload = 'auto';
        try { b.load(); } catch (e) {}
      });

      function swap() {
        switching = true;
        idle.currentTime = 0;
        idle.playbackRate = rate;
        var p = idle.play();
        if (p && p.catch) p.catch(function () {});
        idle.style.opacity = 1;
        active.style.opacity = 0;
        var prev = active;
        active = idle;
        idle = prev;
        setTimeout(function () {
          try { prev.pause(); prev.currentTime = 0; } catch (e) {}
          switching = false;
        }, fade * 1000 + 100);
      }

      // timeupdate rather than requestAnimationFrame: rAF stops in a
      // background tab while the video keeps playing, and a non-looping
      // clip would then end and freeze. timeupdate keeps firing, and the
      // ended handler is the net for anything that slips past it.
      function check(ev) {
        var v = ev.target;
        if (v !== active || switching || !v.duration) return;
        // The fade lasts fade real seconds, which is fade * rate seconds of media.
        if (v.currentTime >= v.duration - trim - fade * rate) swap();
      }
      function ended(ev) {
        if (ev.target === active && !switching) swap();
      }
      [a, b].forEach(function (v) {
        v.addEventListener("timeupdate", check);
        v.addEventListener("ended", ended);
      });

      var start = a.play();
      if (start && start.catch) start.catch(function () {});
    }

    function init() {
      document.querySelectorAll('[data-loop-crossfade]').forEach(bind);
    }

    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState !== 'loading') init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.matchMedia) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!reduce.matches) return;
    document.querySelectorAll('[data-reduced-motion-pause] video').forEach(function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
